export enum ArticleUnity {
  KG = 'KG',
  PIECE = 'PIECE',
  M2 = 'M2',
}
